import initialEdges from "@/modules/crm/automation/flow-design/edges/initial-edges";
import {
  NodeTypeEnum,
  autoPositionNodes,
  calculatePosition,
  createAddConditionNode,
  createEdge,
  createNode,
  getHighestId,
  initialNodeDefaultText,
  nodeInfoGenerator,
  shallowCopy,
} from "@/modules/crm/automation/flow-design/helper";
import initialNodes from "@/modules/crm/automation/flow-design/nodes/initial-nodes";
import { Enums } from "@/services/dropdown-enums";
import { ToastTemplate } from "@/services/variables";
import { createSlice } from "@reduxjs/toolkit";
import { toast } from "react-toastify";

/**
 * @name @createSlice
 * @description create redux store slice for Workflow Designer
 **/
export const WFDesignerSlice = createSlice({
  name: "WFDesigner",
  initialState: {
    nodeId: "1",
    firstNodeInfo: null,
    initialNodeText: initialNodeDefaultText,
    selectedNodeInfo: null,
    loadingFlow: false,
    nodes: initialNodes,
    edges: initialEdges,
    selectedEdgeInfo: null,
    disabledWF: false,
    buttonClicked: false,
    openRightPanel: false,
    openWarningModal: false,
    isNodeDeleted: false,
  },

  reducers: {
    setNodeIdToState: (state, action) => {
      state.nodeId = action.payload;
    },
    setInitialNodeTextToState: (state, action) => {
      state.initialNodeText = action.payload;
    },
    setLoadingFlowToState: (state, action) => {
      state.loadingFlow = action.payload;
    },
    setSelectedNodeInfoToState: (state, action) => {
      state.selectedNodeInfo = action.payload;
    },
    setSelectedEdgeInfoToState: (state, action) => {
      state.selectedEdgeInfo = action.payload;
    },
    setNodesToState: (state, action) => {
      state.nodes = action.payload;
    },
    setEdgesToState: (state, action) => {
      state.edges = action.payload;
    },
    setDisabledWFToState: (state, action) => {
      state.disabledWF = action.payload;
    },
    setButtonClickedToState: (state, action) => {
      state.buttonClicked = action.payload;
    },
    setOpenRightPanelToState: (state, action) => {
      state.openRightPanel = action.payload;
    },
    setOpenWarningModalToState: (state, action) => {
      state.openWarningModal = action.payload;
    },
    setIsNodeDeletedToState: (state, action) => {
      state.isNodeDeleted = action.payload;
    },
    setFirstNodeInfoToState: (state, action) => {
      state.firstNodeInfo = action.payload;
    },
  },
});

export const {
  setNodeIdToState,
  setInitialNodeTextToState,
  setSelectedNodeInfoToState,
  setLoadingFlowToState,
  setSelectedEdgeInfoToState,
  setNodesToState,
  setEdgesToState,
  setDisabledWFToState,
  setButtonClickedToState,
  setOpenRightPanelToState,
  setOpenWarningModalToState,
  setIsNodeDeletedToState,
  setFirstNodeInfoToState,
} = WFDesignerSlice.actions;

/* called a selector and allows to select values from the state */

export const getNodeIdState = (state) => {
  return state.WFDesigner.nodeId;
};

export const getInitialNodeTextState = (state) => {
  return state.WFDesigner.initialNodeText;
};

export const getSelectedNodeInfoState = (state) => {
  return state.WFDesigner.selectedNodeInfo;
};
export const getLoadingFlow = (state) => {
  return state.WFDesigner.loadingFlow;
};

export const getSelectedEdgeInfoState = (state) => {
  return state.WFDesigner.selectedEdgeInfo;
};

export const getNodes = (state) => {
  return state.WFDesigner.nodes;
};
export const getEdges = (state) => {
  return state.WFDesigner.edges;
};

export const getDisabledWF = (state) => {
  return state.WFDesigner.disabledWF;
};

export const getButtonClicked = (state) => {
  return state.WFDesigner.buttonClicked;
};

export const getOpenRightPanelState = (state) => {
  return state.WFDesigner.openRightPanel;
};
export const getOpenWarningModalState = (state) => {
  return state.WFDesigner.openWarningModal;
};

export const getIsNodeDeletedState = (state) => {
  return state.WFDesigner.isNodeDeleted;
};

export const getFirstNodeInfoState = (state) => {
  return state.WFDesigner.firstNodeInfo;
};

export const onAddNode =
  (sourceId, targetId, stepData) => (dispatch, getState) => {
    console.log("onAdd Node", getState().WFDesigner.nodes);
    // // node data , place , add step number
    let WFStates = getState().WFDesigner;
    let tempNodes = JSON.parse(JSON.stringify(WFStates?.nodes));
    let targetIndex = tempNodes.findIndex((node) => node.id === targetId);
    let addIndex = targetIndex !== -1 && stepData?.isAddBelow ? 1 : 0;
    // // if adding node in middle
    if (targetIndex !== -1) {
      let aboveNodes = tempNodes.slice(0, targetIndex + addIndex);
      let belowNodes = shallowCopy(
        tempNodes.slice(targetIndex + addIndex, tempNodes.length)
      );
      console.log("remaining nodes", belowNodes);
      let selectedNode = shallowCopy(tempNodes[targetIndex]);

      //create new one here
      let info = {
        node: {
          ...selectedNode,
          id: (+WFStates?.nodeId + 1).toString(),
          parentId: addIndex ? selectedNode?.id : selectedNode?.parentId,
        },
        data: stepData,
      };
      let isMiddleNode = true;
      let { newNode } = nodeInfoGenerator(info, isMiddleNode);
      dispatch(setNodeIdToState(newNode?.id));
      // setting selectedNodeInfo state to update the node later
      // if (stepData?.nodeType === NodeTypeEnum.Initial) {
      //   dispatch(setSelectedNodeInfoToState({ ...newNode }));
      // }

      // update below nodes here
      if (belowNodes.length) {
        let firstBelowNode = belowNodes[0];
        let FBNType = firstBelowNode.type;
        let changeXPosition =
          FBNType === NodeTypeEnum.Condition && addIndex <= 0;

        belowNodes = belowNodes.map((node) => {
          // let id = makeId(node.id);
          let id = node.id;
          let position = calculatePosition(
            node,
            node?.position?.x,
            changeXPosition
          );
          // updating parentId for condition nodes if new node is going to be added above them

          let parentId =
            (node?.parentId === selectedNode?.id && addIndex > 0) ||
            node?.id == selectedNode?.id
              ? newNode?.id
              : node?.parentId;

          let updatedNode = createNode({ ...node, id, position, parentId });
          return updatedNode;
        });
      }

      console.log("below updated nodes", belowNodes);

      let mergeAll = [...aboveNodes, newNode, ...belowNodes];

      // dispatch(setNodesToState(mergeAll));
      // dispatch(onAddEdge(edgeOption, newNode));

      return { allNodes: mergeAll, newNode };
    } else {
      // check for middle node selected in case of condition node
      // when condition node is selected/focused then any new node will be created below or beside it
      let middleNode = WFStates.selectedNodeInfo;
      let isCreateNewInMiddle =
        middleNode && middleNode?.selected && middleNode?.shouldCreateNew;

      // adding new node in last
      let lastNode = isCreateNewInMiddle
        ? middleNode
        : tempNodes[tempNodes.length - 1];

      if (sourceId && stepData?.nodeType == NodeTypeEnum.Initial) {
        lastNode = tempNodes.find((node) => node?.id == sourceId);
      }

      if (!sourceId && lastNode?.type == NodeTypeEnum.AddConditionNode) {
        lastNode = tempNodes.find((node) => node?.id == lastNode?.parentId);
      }

      let isLastNodeConditionNode = lastNode?.type === NodeTypeEnum.Condition;
      let isNewNodeForCondition = stepData?.nodeType === NodeTypeEnum.Condition;
      let parentId = isLastNodeConditionNode
        ? isNewNodeForCondition
          ? lastNode?.parentId
          : lastNode?.id || lastNode?.id
        : lastNode?.id;
      // let parentId = isConditionNodeORFirstNode
      //   ? lastNode?.parentId || lastNode?.id
      //   : lastNodeParentNode?.id;
      console.log("last node type:", lastNode);

      if (!sourceId && lastNode?.type == NodeTypeEnum.Trigger) {
        parentId = lastNode?.id;
      }

      if (!validateConditionNode(stepData, lastNode, tempNodes)) {
        toast.error(ToastTemplate.error(conditionValidationError));
        return { allNodes: tempNodes };
      }

      //create new one here
      let info = {
        node: {
          ...lastNode,
          // id:WFStates?.nodeId,
          id: (+getHighestId(tempNodes) + 1).toString(),
          parentId: parentId,
          // parentType: lastNodeParentNode?.type,
        },
        data: stepData,
      };
      let { newNode, isInitialNode } = nodeInfoGenerator(info);

      dispatch(setNodeIdToState(newNode?.id));
      // setting selectedNodeInfo state to update the node later
      // if (
      //   stepData?.nodeType === NodeTypeEnum.Initial &&
      //   stepData?.showCancelIcon
      // ) {
      //   dispatch(setSelectedNodeInfoToState({ ...newNode }));
      // }

      if (isInitialNode && tempNodes.length < 2) {
        tempNodes = [newNode];
      } else {
        tempNodes.push(newNode);
      }

      if (
        newNode?.type === NodeTypeEnum.Condition ||
        (newNode?.type === NodeTypeEnum.Initial &&
          newNode?.data?.isConditionNode)
      ) {
        tempNodes = moveAddConditionNodeInLast(tempNodes, newNode);
      }

      // dispatch(setNodesToState(tempNodes));
      // dispatch(onAddEdge(edgeOption, newNode));

      return { allNodes: tempNodes, isInitialNode, newNode };
    }
  };

export const onAddEdge =
  (edgeOption = null, newNodeInfo = null) =>
  (dispatch, getState) => {
    console.log("addEdge--", edgeOption, newNodeInfo);
    let WFStates = getState().WFDesigner;
    let { id, source, target } = WFStates?.selectedEdgeInfo || edgeOption || {};
    let tempEdges = JSON.parse(JSON.stringify(WFStates?.edges));
    let targetIndex = tempEdges.findIndex((edge) => edge.id === id);
    // // if adding edge in middle
    if (targetIndex !== -1) {
      let aboveEdges = tempEdges.slice(0, targetIndex);
      let belowEdges = tempEdges.slice(targetIndex + 1, tempEdges.length);

      let oldEdge = tempEdges[targetIndex];
      let newNodeId = newNodeInfo?.id?.toString();
      oldEdge = createEdge({
        ...oldEdge,
        target: newNodeId,
      });

      // in newEdge source will be same , target will be new node id
      // in existing edge source will be new node id , target will be same

      //create new one here
      let isNewEdge = true;
      let newSource = newNodeId;
      let newEdge = createEdge({ id, source: newSource, target, isNewEdge });

      // let mergeAll = [...aboveEdges, newEdge, ...belowEdges];
      let mergeAll = [...aboveEdges, oldEdge, newEdge, ...belowEdges];
      // dispatch(setEdgesToState(mergeAll));
      return mergeAll;
    } else {
      // check for middle node selected in case of condition node
      // when condition node is selected/focused then any new node will be created below or beside it
      let middleNode = WFStates.selectedNodeInfo;
      let isAddActionNodeForConditionNode = middleNode?.isConditionNode;
      let isCreateNewInMiddle =
        middleNode && middleNode.selected && middleNode?.shouldCreateNew;

      // adding new edge in last
      let lastNode = isCreateNewInMiddle
        ? middleNode
        : WFStates?.nodes[WFStates?.nodes.length - 1];

      if (newNodeInfo.type === NodeTypeEnum.Initial && source) {
        lastNode = WFStates?.nodes.find((node) => node?.id == source);
      }
      if (lastNode.type === NodeTypeEnum.AddConditionNode) {
        lastNode = WFStates?.nodes.find(
          (node) => node?.id == lastNode?.parentId
        );
      }

      let newNodeId = newNodeInfo?.id?.toString();

      // if lastNode is condition node
      // then we have to connect new edge with lastNode's parent node which should not be conidition node
      let isConditionNode = lastNode?.type === NodeTypeEnum.Condition;
      let isNewNodeIsConditionNode =
        newNodeInfo?.type === NodeTypeEnum.Condition;
      //create new one here
      let isNewEdge = true;
      let newEdge = createEdge({
        source:
          isNewNodeIsConditionNode && isConditionNode && newNodeInfo?.parentId
            ? newNodeInfo?.parentId
            : lastNode?.id,
        // source: source,
        target: newNodeId,
        type:
          isNewNodeIsConditionNode || isAddActionNodeForConditionNode
            ? "smoothstep"
            : "buttonedge",
        // type: "buttonedge",
        isNewEdge,
      });

      //update condition nodes edges when adding new nod above them
      let shouldUpdateEdges = newNodeInfo?.data?.isAddBelow;
      if (shouldUpdateEdges) {
        tempEdges.map((edge) => {
          if (edge.source === lastNode?.id) {
            edge.source = newNodeId;
          }
        });
      }
      let lastSourceIndex = tempEdges.findLastIndex((edge) =>
        shouldUpdateEdges
          ? edge.target === newEdge.source
          : edge.source === newEdge.source && !isNaN(edge.target)
      );
      if (
        (newEdge.type === "smoothstep" && lastSourceIndex != -1) ||
        shouldUpdateEdges
      ) {
        tempEdges.splice(lastSourceIndex + 1, 0, newEdge);
      } else {
        tempEdges.push(newEdge);
      }
      // setEdges(tempEdges);
      // dispatch(setEdgesToState(tempEdges));
      return tempEdges;
    }
  };

export const addNewNodeHandler =
  (stepData, edgeOption = null) =>
  async (dispatch, getState) => {
    let WFStates = getState().WFDesigner;
    console.log(
      "selectedEdgeInfo",
      WFStates?.selectedEdgeInfo,
      stepData,
      edgeOption
    );
    let { source, target } = WFStates?.selectedEdgeInfo ||
      edgeOption || { source: "", target: "" };

    //add new node here
    let { allNodes, isInitialNode, newNode } = await dispatch(
      onAddNode(source, target, stepData)
    );
    // setNodes(allNodes);
    console.log("updatedNodes", allNodes);
    if ((!isInitialNode || allNodes.length > 1) && newNode) {
      // //add new Edge here
      let updatedEdges = await dispatch(onAddEdge(edgeOption, newNode));

      let modifiedFlow = addConditionNodeInLastOfConditionsRaw(
        newNode,
        allNodes,
        updatedEdges
      );
      dispatch(setEdgesToState(modifiedFlow.allEdges));
      console.log("Wf Nodes", WFStates?.nodes);
      console.log("all edges", updatedEdges);
    }

    console.log("all Nodes", allNodes);

    dispatch(setNodesToState(allNodes));
    dispatch(setSelectedEdgeInfoToState(null));

    // if (WFStates.selectedNodeInfo?.shouldCreateNew) {
    //   dispatch(setSelectedNodeInfoToState(null));
    // }

    // setting selectedNodeInfo state to update the node later
    if (
      ((newNode?.type === NodeTypeEnum.Initial &&
        newNode?.data?.showCancelIcon) ||
        WFStates.selectedNodeInfo?.shouldCreateNew) &&
      newNode
    ) {
      dispatch(setSelectedNodeInfoToState({ ...newNode }));
    }

    // dispatch(reRenderNodes(allNodes));

    return allNodes;
  };

// repositioning nodes
export const reRenderNodes =
  (allNodes = [], runAfter = 500) =>
  (dispatch, getState) => {
    // re-positioning nodes after template added
    setTimeout(() => {
      let WFStates = getState().WFDesigner;
      // let tempNodes = shallowCopy(allNodes);
      // let tempEdges = shallowCopy(WFStates.edges);
      // tempNodes = autoPositionNodes(tempNodes, tempEdges);
      // dispatch(setNodesToState(tempNodes));
      dispatch(setLoadingFlowToState(false));
    }, runAfter);
  };
export default WFDesignerSlice.reducer;

export const getValidParent = (prev, allNodes = []) => {
  if (prev?.type == NodeTypeEnum.Initial) {
    let temp = allNodes.find((node) => node?.id == prev?.parentId);
    return getValidParent(temp, allNodes);
  }

  if (
    prev?.type === NodeTypeEnum.Delay ||
    prev?.type === NodeTypeEnum.Condition ||
    prev?.nodeType === NodeTypeEnum.Condition
  ) {
    let temp = allNodes.find((node) => node?.id == prev?.parentId);
    return getValidParent(temp, allNodes);
  } else {
    return prev;
  }
};
export const getValidChild = (prev, allNodes = []) => {
  let type = prev?.type || prev?.nodeType;
  // if (prev?.type == NodeTypeEnum.Initial) {
  //   let temp = allNodes.find((node) => node?.parentId == prev?.id);
  //   return getValidParent(temp, allNodes);
  // }

  if (type == NodeTypeEnum.Initial || type === NodeTypeEnum.Delay) {
    let temp = allNodes.find((node) => node?.parentId == prev?.id);
    return getValidChild(temp, allNodes);
  } else {
    return prev;
  }
};

export const validateConditionNode = (
  newNodeData = {},
  prevNode = {},
  allNodes = [],
  selected
) => {
  let isValid = true;

  let parentNode = getValidParent(
    selected?.parentId ? selected : prevNode,
    allNodes
  );
  let childNode = getValidChild(
    selected?.parentId ? selected : prevNode || prevNode,
    allNodes
  );

  if (
    newNodeData.nodeType === NodeTypeEnum.Condition &&
    newNodeData.conditionId !== Enums.WFTemplateConditionType.Lead
  ) {
    if (
      // scenario#1 : when last node is action node and condition type is not same as action type
      (parentNode?.data?.nodeType === NodeTypeEnum.Email &&
        newNodeData.conditionId !== Enums.WFTemplateConditionType.Email) ||
      (parentNode?.data?.nodeType === NodeTypeEnum.SMS &&
        newNodeData.conditionId !== Enums.WFTemplateConditionType.SMS)
    ) {
      isValid = false;
    }
  } else {
    if (
      childNode?.type == NodeTypeEnum.Condition &&
      childNode?.data?.conditionId !== Enums.WFTemplateConditionType.Lead
    ) {
      let child = allNodes.find(
        (node) =>
          node?.parentId == childNode.parentId &&
          node?.data?.conditionId != Enums.WFTemplateConditionType.Lead
      );
      if (
        (newNodeData?.nodeType === NodeTypeEnum.Email &&
          child?.data?.conditionId !== Enums.WFTemplateConditionType.Email) ||
        (newNodeData?.nodeType === NodeTypeEnum.SMS &&
          child?.data?.conditionId !== Enums.WFTemplateConditionType.SMS)
      ) {
        isValid = false;
      }
    }
  }
  return isValid;
};

export const conditionValidationError =
  "Please add an SMS or Email action before using a corresponding SMS or Email condition.";

export const addConditionNodeInLastOfConditionsRaw = (
  newNode,
  allNodes,
  allEdges
) => {
  if (newNode.type === NodeTypeEnum.Condition) {
    let y_nodes = allNodes.filter((node) => node.parentId === newNode.parentId);

    if (y_nodes.length) {
      let haveConditionNodes = y_nodes.some(
        (node) => node.type === NodeTypeEnum.Condition
      );
      let addConditionNodeNotExist = y_nodes.every(
        (node) => node.type !== NodeTypeEnum.AddConditionNode
      );

      if (haveConditionNodes && addConditionNodeNotExist) {
        let lastNode = y_nodes[y_nodes.length - 1];
        let parentEdge = allEdges.find((edge) => edge.target == lastNode.id);
        lastNode = { ...lastNode, parentId: parentEdge?.source };
        let { addConditionNode, addConditionEdge } =
          createAddConditionButton(lastNode);
        console.log("add condition node array", addConditionNode);
        allNodes.push(addConditionNode);
        allEdges.push(addConditionEdge);
      }
    }
  }
  return { allNodes, allEdges };
};

export const createAddConditionButton = (lastNode) => {
  let newId = `${Date.now()}_${Math.random().toString(36).substring(2, 9)}`; // making unique id
  let addConditionNode = createAddConditionNode(newId, lastNode);
  let addConditionEdge = createEdge({
    target: addConditionNode?.id,
    source: lastNode?.parentId,
    type: "smoothstep",
  });

  return { addConditionNode, addConditionEdge };
};

export const moveAddConditionNodeInLast = (allNodes, newNode) => {
  // get newNode position
  let newNodePosition = shallowCopy(newNode.position);

  // get addConditionNode index of same y position if available
  let addConditionNodeIndex = allNodes.findIndex(
    (node) =>
      node?.parentId === newNode.parentId &&
      node.type === NodeTypeEnum.AddConditionNode
  );

  if (addConditionNodeIndex !== -1) {
    // get addConditionNode info from allNodes and exchange position with newNode position
    let addConditionNode = allNodes[addConditionNodeIndex];
    let addConditionPosition = shallowCopy(addConditionNode.position);
    allNodes[addConditionNodeIndex] = {
      ...addConditionNode,
      position: newNodePosition,
    };
    newNode = { ...newNode, position: addConditionPosition };

    // add newNode before addConditionNode, in order to push addConditionNode in last
    allNodes.splice(addConditionNodeIndex, 0, newNode);
    // remove newNode from last in allNodes to avoid duplication
    allNodes.pop();
  }

  return allNodes;
};
